import axios from "axios";
import { config } from "./config";


const getCsrfToken = () => {
    const match = document.cookie.match(new RegExp('(^| )csrftoken=([^;]+)'));
    return match ? match[2] : null;
};

export const request = axios.create({
    baseURL: config.baseURL,
    withCredentials: true,
})

request.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = "Bearer " + token;
    }

    const csrfToken = getCsrfToken()
    if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }
    return config
}, (error) => {
    return Promise.reject(error);
});